

export function countries(){
    let countries = require('./countries.json');
    return countries;
}
